<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <GraphDrawerControls
      :drawer="drawer"
      @set-pinned="setDrawerPinned({ pinned: $event })"
      @set-highlighted="setDrawerHighlighted({ highlighted: $event })"
      @confirm-replace="saveGraph({ replaceMainChart: true })"
      @cancel-replace="cancelReplaceMainChart"
    />
    <GraphLanguageSelect
      v-model="locale"
      :languages="graphAvailableLanguages"
    />
    <SfButtonDs
      v-if="isPersisted && !readOnly"
      variant="danger"
      @click="destroyWithConfirm()"
    >
      {{ I18n.t('js.report_graph.edit.destroy') }}
    </SfButtonDs>
    <SfButtonDs
      v-if="!readOnly"
      variant="primary"
      :loading="saving"
      :disabled="saveDisabled"
      data-walkthrough-id="chart-editor-save"
      @click="submit()"
    >
      {{ I18n.t('js.report_graph.edit.save') }}
    </SfButtonDs>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

import GraphDrawerControls from './graph-drawer-controls.vue'
import GraphLanguageSelect from './graph-language-select.vue'

const ENTER = 'Enter'
const TEXTAREA = 'TEXTAREA'

export default {
  components: { GraphDrawerControls, GraphLanguageSelect, SfButtonDs },
  computed: {
    ...mapState(['currentLocale', 'readOnly', 'saving', 'drawer']),
    ...mapGetters([
      'graphCurrentTitle',
      'graphAvailableLanguages',
      'isPersisted',
      'hasUnsavedChanges',
    ]),
    // A new graph has nothing saved to compare against, so it can always be
    // saved. A persisted one can be saved once something changed.
    saveDisabled() {
      return this.isPersisted && !this.hasUnsavedChanges
    },
    locale: {
      get() {
        return this.currentLocale
      },
      set(newLocale) {
        this.setCurrentLocale({ locale: newLocale })
      },
    },
  },
  mounted() {
    if (!this.readOnly) {
      this._keyHandler = (event) => {
        if (event.key === ENTER && event.target.tagName !== TEXTAREA) {
          this.submit()
        }
      }
      document.body.addEventListener('keyup', this._keyHandler)
    }
  },
  beforeUnmount() {
    if (this._keyHandler)
      document.body.removeEventListener('keyup', this._keyHandler)
  },
  methods: {
    ...mapActions([
      'setCurrentLocale',
      'deleteGraph',
      'saveGraph',
      'setDrawerPinned',
      'setDrawerHighlighted',
      'cancelReplaceMainChart',
    ]),
    destroyWithConfirm() {
      window.sfRemoveConfirm({
        name: this.graphCurrentTitle,
        onConfirm: this.deleteGraph,
      })
    },
    submit() {
      if (this.saveDisabled) return
      this.saveGraph()
    },
  },
}
</script>
